import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
 import FaCopy from 'react-icons/lib/fa/copy';
import {
    ADD_SELECTED_CONTRACTORS,REMOVE_SELECTED_CONTRACTORS  }  from "actions/actionTypes";
import config from  '../../../../config';
import moment from 'moment'
import {getFieldByPathFormatter,priceFormatter,imagesFormatter,  linkFormatter, customTableSelect,customFormatter,dateFormatter, actionsFormatter} from 'util/Utils';
class AMTSalesNotificationsListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            recordIDs:[],
            perPage: config.table.numberPerPage
        };
    }
    customActionsFormatter(cell, row, extra){
        var menuItemsMap  =    [  ]
        menuItemsMap.push({onClick: (row)=> {
            this.props.deleteSubscription(row)
        }, label: 'Delete'})

        return  actionsFormatter.call(this, cell, row, {menuItemsMap})
    }
    onRowSelect(row, isSelected, e) {
         var actionName =   isSelected ? ADD_SELECTED_CONTRACTORS : REMOVE_SELECTED_CONTRACTORS;
         this.props.dispatchAction([row], actionName)
    }
    onAllRowSelect(isSelected, rows){
        var actionName =   isSelected ? ADD_SELECTED_CONTRACTORS : REMOVE_SELECTED_CONTRACTORS;
        this.props.dispatchAction(rows, actionName)
    }
    customMultiSelect(props) {
       return customTableSelect(props, {table:this.refs.table, selectedRows:this.props.adminContractors.selectedContractors});
    }


    render() {
        const  selectRowProp = {
            mode: 'checkbox',
            columnWidth: '29px',
            onSelect: this.props.onRowSelect,
            onSelectAll: this.props.onAllRowSelect,
            customComponent: this.props.customMultiSelect

        }

        return (
            <div className="panel panel-default">
                <div className=" databases-table">
                    <BootstrapTable ref='table'
                                    data={this.props.tableData}
                                //    selectRow={ selectRowProp }
                                    remote={true}
                                    hover={true}
                                    condensed={true}
                                    striped={true}
                                    options={ {
                                        ...config.bootstrapTableOptions,
                                        onSortChange: this.props.onSortChange
                                    } } >
                        <TableHeaderColumn width="150px" dataField='Product.ProductName' dataAlign="center"
                                           dataFormat={ linkFormatter } formatExtraData={ {
                            labelPath: ['Product', 'ProductName'],
                            path: ['Product', 'ShopifyProductHandle'],
                            placeholder: '[product_handle]',
                            template: config.getEnvironment().shopify.productCustomerUrlTemplate
                        } }           dataSort={true}>Product Name</TableHeaderColumn>
                        <TableHeaderColumn width="150px" dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                           hiddenOnInsert>Id</TableHeaderColumn>
                         <TableHeaderColumn width="60px" dataField='Type' dataAlign="center"    dataFormat={ customFormatter }
                            formatExtraData={ {path:[  'getObject']  , format: (row)=> {
                                 var foundType =  _.find(config.subscriptionTypes, function (value, key) {
                                    return key == row.Type
                                })
                                return foundType ? foundType.label  : ''
                        }}} dataSort={true}>Notifications Type</TableHeaderColumn>
                         <TableHeaderColumn width="70px" dataField='EmailsSent.createdAt'  dataAlign="center"
                                            dataFormat={ customFormatter }
                                            formatExtraData={ {path:[  'getObject']  , format: (row)=> {
                                            var emailsSent = _.map(_.get(row, 'EmailsSent',[]),item =>{
                                                return moment(item.createdAt).format('MM/DD')
                                            })

                                                return <div>
                                                        {emailsSent.length ? emailsSent.join(', '):null}
                                                </div>
                                            }
                                            }}
                                           dataSort={true}>Sent</TableHeaderColumn>
                        <TableHeaderColumn width="30px" dataAlign="center"  columnClassName={'actions-column'}
                                           dataFormat={ this.customActionsFormatter.bind(this) }
                        >Actions</TableHeaderColumn>
                    </BootstrapTable>
                </div>

            </div>

        );
    }
}


export default AMTSalesNotificationsListTable;
